import React from 'react'

import { exists } from '~/utils'

import { useSurveyQueryBrandGroups } from './useSurveyQueryBrandGroups'

export const useSurveyQueryAvailableBrandGroups = () => {
  const brandGroups = useSurveyQueryBrandGroups()

  return React.useMemo(
    () => brandGroups.filter((brandGroup) => exists(brandGroup.mappedAt)),
    [brandGroups],
  )
}
